import React, { Component } from 'react';
import { Switch, Spin, Tooltip, Modal, Button, notification, Pagination,Avatar,Empty } from 'antd';
import { LeftOutlined, RightOutlined,UndoOutlined,CloseOutlined,UserOutlined } from '@ant-design/icons';
import { CSVLink } from "react-csv";
import moment from 'moment';
// import formDataSchema from '../../schema/work-list';
import Select2 from '../../components/FormComponent/select2';
import Inputlayer from '../../components/FormComponent/Input';
import { filter, formData, dissableFormData } from '../../schema/apppointment';
// import Pagination from "react-js-pagination";
import { interim_enhacement_search } from '../../schema/bill-tacking';
import networkList from '../../constants/networkList';
import postService from '../../services/httpService';


const $ = require('jquery');
const { addCounsellorComments, getCounsellorCommentsByPatient, homepage }= networkList
class Interim_Enhacement extends Component {
    csvLink = React.createRef()
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            'thead': [],
            'tbody': [], 
            downloadStatus: 0,
             downloadtbody: [],
             search_key:'',
             totalItemsCount: 0,
             commentModal: false,
            comments: null,
            patient_details: {},
            commentsArray: []
        };
    }

    // itemRender(current, type, originalElement) {
    //     if (type === 'prev') {
    //         return <a><LeftOutlined /></a>;
    //     }
    //     if (type === 'next') {
    //         return <a><RightOutlined /></a>;
    //     }
    //     return originalElement;
    // }

    // showBillDetails = (ip,latest_counselled_by) => {
    //     this.props.history.push('/counselling/basic-details');
    //     if (ip != null && latest_counselled_by !== null) {
    //         this
    //             .props
    //             .history
    //             .push(`/interim-enhacement-details`, ip);
    //     } else {
    //         // notification.error({
    //         //     message: 'Failure',
    //         //     description: 'Oops, something went wrong... Please try again.',
    //         //     duration: 10,
    //         //     top: 20,
    //         //     right: 0
    //         // });
    //     }

    //     // alert(ip)
    // }

    componentDidMount() {
        let formSchema = Object.assign({}, interim_enhacement_search);
        this.setState({ activePage: 1, totalItemsCount: 0,'formData': formSchema['feilds'],search_key: '' }, () => {
            this.loadPage()
        });
    }

    componentWillUnmount() {
        $('footer').css({ 'position': 'relative', top: 'unset' });
        this.setState({ formData: [] });
    }

    loadPage = () => {
        try {
            let This = this;
            let userData = localStorage.getItem('user_data');
            const { getInterimEnhancementsWorklist } = networkList;
            let { activePage } = this.state;
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }

            let tableHead = [
                {
                    "key": 'patient_name',
                    'label': 'Patient Name'
                }, {
                    "key": 'ip_no',
                    'label': 'IP Number'
                }, {
                    "key": 'umr_no',
                    'label': 'UMR Number'
                },
                {
                    "key": 'admission_date',
                    'label': 'Admission Date'
                }, {
                    "key": 'fc_payer_type',
                    'label': 'FC Payer Type'
                },
                {
                    "key": 'hims_payer_type',
                    'label': 'Hims Payer Type'
                }, {
                    "key": 'org_name',
                    'label': 'organization'
                }, {
                    "key": 'care_management',
                    'label': 'Care Management'
                }, {
                    "key": 'estimate_type',
                    'label': 'Estimate Type',
                }, 
                {
                    "key": 'los',
                    'label': 'LOS'
                }
                , {
                    "key": 'dos',
                    'label': 'DOS'
                },
                {
                    "key": 'last_counselling_amount',
                    'label': 'Last counselled Amount  (Rs.)'
                }, {
                    "key": 'last_counselling_date',
                    'label': 'Last counselled date'
                }, {
                    "key": 'latest_counselled_by',
                    'label': 'Last Counselled By'
                }, {
                    "key": 'app_bill_amount',
                    'label': 'Approx bill (Rs.)'
                }, {
                    "key": 'last_approved_amount',
                    'label': 'Last Approved Amount (Rs.)'
                }, {
                    "key": 'insurance_status',
                    'label': 'Status'
                },{
                    "key": 'interim_flag_status',
                    'label': 'Trigger Status '
                },
                
                // , {
                //     "key": 'check_out',
                //     'label': 'Check Out'
                // }
            ]
           
            this.setState((state) => ({downloadStatus: 0, tbody: [], tableTitle: 'Interim Enhancements', thead: tableHead, loadding: false}), () => {
                postService(getInterimEnhancementsWorklist, 'POST', {
                    "data": {
                        "unit_id":userData ? userData['unitid'] ? userData['unitid'] :null :null,
                        "search_key": this.state.search_key ? this.state.search_key : "",
                        "export": 0, //1 for download excel
                        "page_no": activePage
                    }
                }).then(res => {
                    console.log('tat report:', res);
                    // console.log('data res:', data)
                    if (res.status) {
                        // res.data.map((data, key) => {
                        //     Object.keys(data).map((dataKey) => {
                        //         if (dataKey === 'admission_date') {
                        //             res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm') : null
                        //         }
                        //         if (dataKey === 'latest_counselled_date') {
                        //             res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm') : null
                        //         }



                        //     })
                        // })
                        // this.setState((state) => ({totalItemsCount: res.total_items, tbody: res.data, loadding: false }));
                        this.setState((state) => ({tbody: res.data, loadding: false ,totalItemsCount:res.total_items}));
                        setTimeout(function () {
                            This.setState((state) => ({ downloadStatus: 1 }))
                        }, 2000);
                    } else {
                        if (res === 401) {

                        } 
                        else {
                            Modal.error({
                                title: 'Failure',
                                content: "Oops! something went wrong... Please try again.",
                            });
                        }
                    }
                });
            });
        } catch (error) {
            console.log(error);
        }
    }

    handleChange(ele) {
    }
   
    downloadFile = () => {
        try {
            let This = this;
            let userData = localStorage.getItem('user_data');
            let { activePage, doctor_id, department_name, payer_type, bill_value, nurse_station_code, ward_type } = this.state;
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            const { getInterimEnhancementsWorklist } = networkList;
            let tableHead = [
                {
                    "key": 'patient_name',
                    'label': 'Patient Name'
                }, {
                    "key": 'ip_no',
                    'label': 'IP Number'
                }, {
                    "key": 'umr_no',
                    'label': 'UMR Number'
                }, {
                    "key": 'admission_date',
                    'label': 'Admission Date'
                },

                 {
                    "key": 'fc_payer_type',
                    'label': 'Payer Type'
                }, 
                {
                    "key": 'hims_payer_type',
                    'label': 'Hims Payer Type'
                },{
                    "key": 'org_name',
                    'label': 'organization'
                }, {
                    "key": 'care_management',
                    'label': 'Care Management'
                }, {
                    "key": 'estimate_type',
                    'label': 'Estimate Type',
                }, 
                {
                    "key": 'los',
                    'label': 'LOS'
                }
                , {
                    "key": 'dos',
                    'label': 'DOS'
                },
                {
                    "key": 'last_counselling_amount',
                    'label': 'Last counselled Amount  (Rs.)'
                }, {
                    "key": 'last_counselling_date',
                    'label': 'Last counselled date'
                }, {
                    "key": 'latest_counselled_by',
                    'label': 'Last Counselled By'
                }, {
                    "key": 'app_bill_amount',
                    'label': 'Approx bill (Rs.)'
                }, {
                    "key": 'last_approved_amount',
                    'label': 'Last Approved Amount (Rs.)'
                }, {
                    "key": 'insurance_status',
                    'label': 'Status'
                },{
                    "key": 'interim_flag_status',
                    'label': 'Trigger Status '
                },
                // , {
                //     "key": 'check_out',
                //     'label': 'Check Out'
                // }
            ]
            let ward_type_value = ''
            if(ward_type){
                if(ward_type.length>1){
                    ward_type_value = 'all'
                }else{
                    ward_type_value = ward_type[0]
                }
            }else{
                ward_type_value = null
            }
            This.setState((state) => ({ downloadStatus: 0, thead: tableHead, loadding: true, filename: 'Interim-Enhancements.csv' }), () => {
                postService(getInterimEnhancementsWorklist, 'POST', {
                    "data": {
                        "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                        "search_key": this.state.search_key ? this.state.search_key : "",
                        // "counselled_by_id": null,
                        "export": 1, //1 for download excel
                        "page_no": activePage,
                       
                      
                    }
                }).then(res => {
                    console.log('tat report:', res);
                    // console.log('data res:', data)
                    if (res.status) {
                        res.data.map((data, key) => {
                            Object.keys(data).map((dataKey) => {
                                // if (dataKey === 'admission_date') {
                                //     res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : 'NA'
                                // }
                                // if (dataKey === 'interim_flag_status') {
                                //     res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm') : 'NA'
                                // }
                                // else {
                                    res.data[key][dataKey] = res.data[key][dataKey] ? res.data[key][dataKey] : 'NA'
                                // }

                            })
                        })
                        This.setState((state) => ({ downloadtbody: res.data, loadding: false, downloadStatus: 1,total_items:res.total_items }));
                        this.csvLink.current.link.click();
                    } else {
                        if (res === 401) {

                        } else {
                            Modal.error({
                                title: 'Failure',
                                content: "Oops! something went wrong... Please try again.",
                            });
                        }
                    }
                });
            });
        } catch (error) {
            console.log(error);
        }
    }
    handlePageChange(page) {
        this.setState((state) => ({
            activePage: page,
            tbody: []
        }), () => {
            this.loadPage();
        })
    }
    itemRender(current, type, originalElement) {
        if (type === 'prev') {
            return <a>Previous</a>;
        }
        if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    }
    searchChange(e) {
        console.log(e.target.value);
        let value = e.target.value
        this.setState((state) => ({
            'search_key': value
        })
        );
    }
    searchClick() {
        this.setState((state) => ({
            activePage: 1,
            tbody: [],
            totalItemsCount: 0,
        }), () => {
            this.loadPage();
            var formFeilds = this.state.formData;
            formFeilds.map((feild, key) => {
            if (feild.name === 'search') {
                formFeilds[key]['value'] = null;
                formFeilds[key]['valid'] = false;
                formFeilds[key]['errors'] = [];
                formFeilds[key]['text'] = 'Patient’s IP or UMR';
            } 
        });
            this.setState({ formData: formFeilds })
        })
    }
    clearFilter = () => {
        this.setState(()=>({  search_key: '', activePage: 1, totalItemsCount: 0 }),
        () => {
            var formFeilds = this.state.formData;
            formFeilds.map((feild, key) => {
                if (feild.name === 'search') {
                    formFeilds[key]['value'] = null;
                    formFeilds[key]['valid'] = false;
                    formFeilds[key]['errors'] = [];
                    formFeilds[key]['text'] = 'Patient Name or IP or UMR';
                    formFeilds[key]['visible']=false;
                } 
            })
            let This= this
            setTimeout(function () {
                formFeilds.map((feild, key) => {
                    if (feild.name === 'search') {
                        formFeilds[key]['visible']=true   
                    }
                })
                This.setState((state) => ({formFeilds:formFeilds}))
                        }, 100);
            this.setState({ formData: formFeilds })
          
            this.loadPage();
        })
    }
    commentsModal = (data) => {
        let This = this
        let user_data 
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        }
        try{
        This.setState((state) => ({  commentModal: true, patient_details: data, loadding: true }), () => {
            postService(getCounsellorCommentsByPatient, 'POST', {
                "data":{
                    "unit_id": user_data['unitid'] ? user_data['unitid'] : null,
                    "ip_no": data.ip_no ? data.ip_no : null
                }
            }).then(res => {
                console.log('comments:', res);                
                if (res.status) {                    
                    This.setState((state) => ({ 'loadding': false, 'commentsArray': res['data']}));                    
                } else {
                    This.setState((state) => ({ 'loadding': false, 'commentsArray': [] }));
                    Modal.error({
                        title: 'Failure',
                        content: res.message ? res.message : "Oops! something went wrong... Please try again.",
                        zIndex: 1022
                    });
                }
            });
        });
    } catch (error) {
        console.log(error);
        this.setState((state) => ({ 'loadding': false }));
        Modal.error({
            title: 'Failure',
            content: "Oops, something went wrong... Please try again.",
            zIndex: 1022
        });
    }        
    }

    comments(event) {
        let value = event.target.value;
        this.setState((state) => ({ 'comments': value ? value : null }));
    }

    submitCommint=()=>{
        let{comments, patient_details}=this.state
        let This = this
        let user_data 
        if (localStorage.getItem('user_data') !== null) {
            user_data = JSON.parse(localStorage.getItem('user_data'))
        }
        if(comments && comments.length>12){
            try{
                This.setState((state) => ({ loadding: true }), () => {
                    postService(addCounsellorComments, 'POST', {
                        "data":{
                            "ip_no": patient_details.ip_no ? patient_details.ip_no : null,
                            "unit_id": user_data['unitid'] ? user_data['unitid'] : null,
                            "comment": comments,
                            "comment_from": "interim worklist",// interim 
                            "doctor_id":patient_details.doctor_id?patient_details.doctor_id:null,
                            "is_iccu":patient_details.is_iccu?patient_details.is_iccu:null

                        }
                    }).then(res => {
                        console.log('comments:', res);                
                        if (res.status) {                
                            Modal.success({
                                title: 'Success',
                                content: res.message ? res.message : "Success",
                                zIndex: 1022
                            });    
                            This.setState((state) => ({ 'loadding': false, comments: null }));
                            This.commentsModal(patient_details)                    
                        } else {
                            This.setState((state) => ({ 'loadding': false }));
                            Modal.error({
                                title: 'Failure',
                                content: res.message ? res.message : "Oops! something went wrong... Please try again.",
                                zIndex: 1022
                            });
                        }
                    });
                });
            } catch (error) {
                console.log(error);
                this.setState((state) => ({ 'loadding': false }));
                Modal.error({
                    title: 'Failure',
                    content: "Oops, something went wrong... Please try again.",
                });
            }        
        }else{
            this.setState((state) => ({ 'loadding': false }));
            Modal.error({
                title: 'Failure',
                content: 'Please enter comment briefly.',
                zIndex: 1022
            })
        }
    }
    render() {
        let { tableTitle, thead, activePage, tbody,formData,downloadStatus,downloadtbody ,filename,totalItemsCount,commentModal,loadding,commentsArray,patient_details,comments} = this.state;
        console.log('formData',formData);
        return (
            <div>
                 <div className="clearfix mx-5">
                <div className="float-left pt-2">
                {tableTitle}
                </div>
                {
                         downloadStatus && tbody != ''
                            ?
                            <div className="float-right mb-2 download sticky-top d-flex flex-row-reverse">                                
                                <button className="btn btn-success text-capitalize" onClick={() => { this.downloadFile() }}><img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /> <span> Download Report</span></button>
                                <CSVLink data={downloadtbody} headers={thead} filename={filename} className="hidden" ref={this.csvLink} />                                
                                <button className="btn btn-light text-capitalize py-1 mr-3" onClick={() => { this.clearFilter() }}><UndoOutlined  className="align-middle pr-2" /><span> Clear</span></button>
                            </div>
                            :
                            <div className="float-right mb-2 download sticky-top d-flex flex-row-reverse">
                                <Button className="btn btn-success-disabled text-capitalize" disabled><img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /><span> Download Report</span></Button>
                                <button className="btn btn-light text-capitalize py-1 mr-3 " onClick={() => { this.clearFilter() }}><UndoOutlined  type="reload" className="align-middle pr-2" /><span> Clear</span></button>                                    
                            </div>
                }
                </div>
                <Spin spinning={this.state.loadding}>
                    <div className="card ml-5 mr-5 mb-5 card-table">
                        <div className="card-header bg8">
                            <div className="clearfix">
                                <div className="float-left pt-1">
                                    
                                </div>
                                <div className=" row">
                                {(formData !== undefined) && <React.Fragment>

                                    {formData
                                        .map((feild, key) => {
                                            if (feild.element === 'input' && feild.visible) {
                                                return (
                                                    <React.Fragment key={key}>
                                                        <div
                                                            className={`${feild.className
                                                                ? feild.className
                                                                : 'col '} ${feild.name}`}
                                                            key={key}>
                                                            <div className="input-group" key={key}>
                                                                {/* <input type="text" id="myInput" className="form-control form-control-sm" aria-label="Text input with dropdown button" placeholder="Patient Name or UMR or IP" /> */}
                                                                <div
                                                                    className='w-100'
                                                                    key={key}>
                                                                    <input type="text" id="myInput" class="form-control form-control-sm" aria-label="Text input with dropdown button" placeholder="Patient Name or IP or UMR" onBlur={this.searchChange.bind(this)} 
                                                                    ref={(inputRef => (this.inputRef = inputRef))}
                                                                     />
                                                                    <div class="input-group-append" style={{ position: 'absolute', right: 0, height: '32px', top: 0 }}>
                                                                        <button class="btn btn-primary btn-sm" type="button" onClick={this.searchClick.bind(this)}><img src={homepage+"/assets/images/icons/search.png"}></img></button>
                                                                    </div>
                                                                </div>
                                                                {/* <div className="input-group-append" style={{position: 'absolute', right: 0, height: '32px'}}>                                                                    
                            <button className="btn btn-primary btn-sm" onClick={this.search}><img src="/assets/images/icons/search.png" /></button>
                        </div> */}
                                                            </div>
                                                        </div>
                                                    </React.Fragment>
                                                )
                                            }
                                            
                                        })}

                                </React.Fragment>}

                            </div>
                            </div>
                        </div>
                        <div className="financial-table table-responsive">
                            <table className="table table-hover table-bordered mb-0 track-bills">
                                <thead>
                                    <tr>
                                        <td className="text-capitalize align-middle">s.no.</td>
                                        {thead.map((head, key) => {
                                            return (<td className="text-capitalize align-middle" key={key}>{head['label']}</td>)
                                        })}
                                    </tr>
                                </thead>
                                {
                                    tbody != ''
                                        ?
                                        <tbody>
                                            {tbody.map((body, key) => {
                                                return (<tr key={key}
                                                //  onClick={this.showBillDetails.bind(this, body.ip_no, body.latest_counselled_by)} style={{ 'cursor': 'pointer' }} 
                                                 >
                                                    <td>{(key + 1) + (activePage > 1 ? 20 * (activePage > 2 ? (activePage - 1) : 1) : 0)}</td>
                                                    {thead.map((head, Hkey) => {
                                                        if (head['key'] === 'ip_no') {
                                                            return (<td key={Hkey} className="text-capitalize"><p style={{ 'cursor': 'pointer','color': 'blue' }}  onClick={()=>{this.commentsModal(body)}}>{body[head['key']] ? body[head['key']] : 'NA'}</p></td>);

                                                        }else if (head['key'] === 'admission_date') {
                                                            return (<td>{body[head['key']] ? moment(body[head['key']]).format('DD-MM-YYYY HH:mm') : '--'}</td>)
                                                        }else if(head['key'] === 'interim_flag_status') {
                                                            let text=body[head['key']] 
                                                            const interim_flag_status = text.split(",");
                                                            if(interim_flag_status.length>1){
                                                                return (<td>
                                                                    {interim_flag_status.map((item, index)=>{
                                                                     return(<p>{index+1+'. '+item}</p>);
                                                                      })}
                                                                     </td>);
                                                            }else{
                                                                return (<td>
                                                                   <p>{interim_flag_status&&interim_flag_status!=""?'1. '+interim_flag_status:'NA'}</p>
                                                                     </td>); 
                                                            }
                                                                    
                                                           
                                                           


                                                        }
                                                        else {
                                                            return (<td key={Hkey} className="text-capitalize">{body[head['key']] ? body[head['key']] : 'NA'}</td>);
                                                        }
                                                        
                                                    })
                                                    }
                                                </tr>)
                                            })}
                                        </tbody>
                                        :
                                        <tbody>
                                            <tr>
                                                <td colSpan="12" className="text-center">
                                                    <img src={homepage+"/assets/images/icons/no-data.svg"} alt="" />
                                                    <p className="no-data mb-0">No Data</p>
                                                </td>
                                            </tr>
                                        </tbody>
                                }
                            </table>
                        </div>

                    </div>
                    {tbody.length >0&&
                    <div className="row justify-content-center align-item-center mx-0">
                        <div className="col pagenation-col mb-3">
                            <Pagination current={this.state.activePage} total={totalItemsCount} itemRender={this.itemRender.bind(this)} pageSize={20} showSizeChanger={false} onChange={this.handlePageChange.bind(this)} />
                        </div>
                    </div>
    }
                    <Modal
                     title=''
                     centere
                     footer={null}
                     width='80%'
                     zIndex='1021'
                     closable={false}
                     maskClosable={false}
                     visible={commentModal}>
                         <Spin spinning={loadding}>
                         <Tooltip title="Close"><CloseOutlined type="close" className="comments-popup-close" onClick={() => this.setState({ commentModal: false,comments: null })} /></Tooltip>
                     <h4 className="text-center pb-4">Comments History</h4>
                     <div className="row pb-3">
                         <div className="col-12 my-auto">
                             <h6 className="mb-0"> <Tooltip title="Patient Name">{patient_details.patient_name ? patient_details.patient_name : '--'}</Tooltip> <span className="mx-3">|</span> <Tooltip title="UMR Number">{patient_details.umr_no ? patient_details.umr_no : '--'}</Tooltip> <span className="mx-3">|</span> <Tooltip title="IP Number">{patient_details.ip_no ? patient_details.ip_no : '--'}</Tooltip></h6>
                         </div>                           
                     </div>
                     <div className="row w-100 mx-auto">
                         <div class="col-12 p-0">
                             <textarea placeholder="Enter your comments..." autoFocus='true' className="textarea" style={{height: '80px'}} value={comments ? comments : ''} onChange={(event) => this.comments(event)}></textarea>
                         </div>                           
                     </div>
                     <div className="text-right">
                         <button className="btn btn-success" onClick={()=>{this.submitCommint()}}>Submit</button>
                         </div>
                     <div class="row pt-3">
                         {commentsArray.map((data,key)=>{                                
                             return <div className="col-12 pb-3">
                                 <div class="media">
                                     {/* <img src="https://www.w3schools.com/bootstrap4/img_avatar3.png" style={{ 'width': '60px' }} /> */}                                        
                                     <div class="align-self-start mr-3">
                                     <Avatar size={50} icon={<UserOutlined />} className="align-middle"/>
                                     </div>
                                     <div class="media-body">
                                         <h6 className='mb-1'><Tooltip title="Created By">{data.created_by}</Tooltip> <span className="mx-3">|</span> <Tooltip title='Created On'><small className="text-muted">{moment(data.created_at).format('DD-MM-YYYY LT')}</small></Tooltip> <span className="mx-3">|</span> <Tooltip title="Comment From"><small className="text-capitalize text-muted"> {data.remarks_from}</small></Tooltip></h6>                                            
                                         <p>{data.remarks}</p>
                                     </div>
                                 </div>
                             </div>
                         })}
                         {commentsArray && commentsArray.length == 0 && <Empty className="mx-auto" description={<span>No history is available for this patient.</span> }/>}
                     </div>
                     </Spin>
                 </Modal>
                </Spin>
            </div>
        )
    }
}

export default Interim_Enhacement;